(() => {
  class SimpleTechWaitlist extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector("form");
      this.variantInput = this.querySelector('[name="shopifyVariantId"]');
      this.status = this.querySelector(".st-waitlist__status");
      this.submitButton = this.querySelector('[type="submit"]');
      const source = this.querySelector("[data-st-waitlist-variants]");
      try {
        this.variants = JSON.parse(source?.textContent || "[]");
      } catch {
        this.variants = [];
      }
      this.onDocumentChange = () => window.requestAnimationFrame(() => this.sync());
      document.addEventListener("change", this.onDocumentChange);
      this.observer = new MutationObserver(() => window.requestAnimationFrame(() => this.sync()));
      this.observer.observe(this.closest("product-info") || this.parentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["value"],
      });
      this.form?.addEventListener("submit", (event) => this.submit(event));
      this.sync();
    }

    disconnectedCallback() {
      document.removeEventListener("change", this.onDocumentChange);
      this.observer?.disconnect();
    }

    selectedVariant() {
      const productForm = document.getElementById(this.dataset.productFormId || "");
      const id = productForm?.querySelector('[name="id"]')?.value;
      return this.variants.find((variant) => String(variant.id) === String(id)) || null;
    }

    sync() {
      const variant = this.selectedVariant();
      const isUnavailable = Boolean(variant && variant.available === false);
      this.hidden = !isUnavailable;
      if (variant && this.variantInput) this.variantInput.value = `gid://shopify/ProductVariant/${variant.id}`;
      if (!isUnavailable) this.setStatus("");
    }

    setStatus(message, state = "") {
      if (!this.status) return;
      this.status.textContent = message;
      if (state) this.status.dataset.state = state;
      else delete this.status.dataset.state;
    }

    async submit(event) {
      event.preventDefault();
      if (!this.form || !this.variantInput || !this.form.reportValidity()) return;
      const endpoint = this.dataset.endpoint;
      if (!endpoint) return;
      const formData = new FormData(this.form);
      const originalLabel = this.submitButton?.textContent;
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.setAttribute("aria-busy", "true");
        this.submitButton.textContent = "Guardando aviso...";
      }
      this.setStatus("");
      try {
        const response = await fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "omit",
          body: JSON.stringify({
            shopifyVariantId: this.variantInput.value,
            email: formData.get("email"),
            name: formData.get("name"),
            consent: formData.get("consent") === "on",
            website: formData.get("website"),
          }),
        });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.error || "No se pudo registrar el aviso.");
        this.form.reset();
        this.setStatus(payload.message || "Listo. Te avisaremos cuando vuelva.", "success");
      } catch (error) {
        this.setStatus(error instanceof Error ? error.message : "No se pudo registrar el aviso.", "error");
      } finally {
        if (this.submitButton) {
          this.submitButton.disabled = false;
          this.submitButton.removeAttribute("aria-busy");
          this.submitButton.textContent = originalLabel || "Avísame cuando esté disponible";
        }
      }
    }
  }

  if (!customElements.get("simple-tech-waitlist")) {
    customElements.define("simple-tech-waitlist", SimpleTechWaitlist);
  }
})();
